<script setup lang="ts">
import { ref, computed } from 'vue'
import { setPatientLanguage } from '@/i18n'
import { useAppStore } from '@/stores/AppStore'
import { getContrastColor } from '@/utils/colorScale'

const appStore = useAppStore()
const props = defineProps<{
  title: string
  color?: string
  logo?: string
}>()

const isSwitchingLanguage = ref(false)

const currentLang = computed(() => appStore.language)

const langText = computed(() => {
  return currentLang.value.toLowerCase() === 'en' ? 'ไทย' : 'EN'
})

async function onClickRight() {
  if (isSwitchingLanguage.value) return
  isSwitchingLanguage.value = true
  const nextLang = currentLang.value === 'en' ? 'th' : 'en'
  try {
    await setPatientLanguage(nextLang)
  } finally {
    isSwitchingLanguage.value = false
  }
}

const textColor = computed(() => {
  if (!props.color) return '#000000'
  return getContrastColor(props.color)
})
</script>

<template>
  <van-nav-bar
    :style="{ backgroundColor: props.color }"
    class="tw-py-3 tw-fixed tw-top-0 tw-w-full"
  >
    <template #left>
      <slot name="left">
        <van-image v-if="props.logo" :src="props.logo" width="30" height="30" />
      </slot>
    </template>

    <template #title>
      <slot name="title">
        <span :style="{ color: textColor }">{{ props.title }}</span>
        <!-- <span class="tw-text-black">{{ props.title }}</span> -->
      </slot>
    </template>
    <template #right>
      <div
        role="button"
        tabindex="0"
        @click="onClickRight"
        @keydown.enter.prevent="onClickRight"
        @keydown.space.prevent="onClickRight"
        class="tw-text-blue-500 tw-text-shadow-lg/30"
      >
        <slot name="right">
          {{ langText }}
        </slot>
      </div>
    </template>
  </van-nav-bar>
</template>
